"use client";

import { Routes } from "@/api";
import { cn } from "@/lib/utils";
import { useCallContext } from "@/providers/call-provider";
import { PropsWithClassName } from "@/types";
import { usePathname } from "next/navigation";
import React from "react";
import { ChatRoomActiveSpeakers } from "./chat-room-active-speakers";
import { ChatRoomOptions } from "./chat-room-options";

export function ChatRoomCallInfo(props: PropsWithClassName) {
  const call = useCallContext();
  const pathname = usePathname();
  const isInbox = pathname?.startsWith(Routes.INBOX);

  const showCallInfo =
    call.channelId.value && call.token && call.activeSpeakerVisible;

  React.useEffect(() => {
    if (!showCallInfo) {
      return;
    }
    const alertUser = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      return (e.returnValue = "");
    };

    const controller = new AbortController();
    const { signal } = controller;

    window.addEventListener("beforeunload", alertUser, { signal });

    return () => {
      controller.abort();
    };
  }, [call, showCallInfo]);

  if (!showCallInfo || isInbox) {
    return null;
  }

  return (
    <ChatRoomActiveSpeakers className={"grow"} avatarSize="sm">
      <ChatRoomOptions
        channelId={call.channelId.value!}
        className={cn("flex-col space-x-0", props.className)}
      />
    </ChatRoomActiveSpeakers>
  );
}
